export default __webpack_public_path__ + "static/media/avatar26.36b57cde.png";